export default __webpack_public_path__ + "static/media/ZTSlogo.e0985665.PNG";